import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useWorkspaceTagSettingsService = function useWorkspaceTagSettingsService(workspaceId) {
  return useQuery(["workspaceTagSettings", workspaceId], function () {
    return servicesUtils.getService("/workspaces/".concat(workspaceId, "/tags/"));
  }, {
    enabled: !!workspaceId
    // onSuccess: (data) => {
    //   if (Array.isArray(data)) {
    //     Store.update((s) => {
    //       s.customFields = data.map((tag: any) => ({
    //         id: tag.id,
    //         uuid: tag.uuid,
    //         tag: tag.tag,
    //         description: tag.description,
    //         tag_type: tag.tag_type,
    //         properties: tag.properties || {},
    //         additional: tag.additional || {
    //           isEnabled: true,
    //           isEditable: true,
    //           isAddToWorklistAsColumn: false,
    //         },
    //         options: tag.options,
    //       }));
    //     });
    //   }
    // },
  });
};
export default useWorkspaceTagSettingsService;